module.exports = __webpack_public_path__ + "static/media/cross-light-blue.fdc5f451.svg";